import { constant } from 'underscore';

export const notComp = f => arg => !f(arg);
export const andComp = (f1, f2) => arg => f1(arg) && f2(arg);
export const orComp = (f1, f2) => arg => f1(arg) || f2(arg);
export const anyComp = (...preds) => preds.reduce(orComp, constant(false));
export const allComp = (...preds) => preds.reduce(andComp, constant(true));

export const entityIs = entityType => e => e.type === entityType;
export const propertyIs = propertyName => e => e.property === propertyName;
export const codeIs = errorCode => e => e.code === errorCode;
